module.exports = __webpack_public_path__ + "img/icon-user.edd26c70.svg";